interface LiveBadgeProps {
  label?: string;
}

export function LiveBadge({ label = 'Live' }: LiveBadgeProps) {
  return (
    <span
      className="badge bg-success bg-opacity-25 text-success"
      style={{ fontSize: '0.65rem' }}
    >
      <span
        className="spinner-grow spinner-grow-sm me-1"
        style={{ width: '0.4rem', height: '0.4rem', verticalAlign: 'middle' }}
      />
      {label}
    </span>
  );
}
